import React, { useContext, useEffect, useRef, useState } from "react";
import { mStatus as mStatusOpt, gender as genderOpt, relation, insuranceType as insuranceTypeOpt, states, dlStatus, FormAuto } from "../..";
import ValidationModal from "../../../ValidationModal";
import AddMemberValidation from "../../../ChangeRequest_AddressChangeComp/ValidationConditions/AddMemberValidation";
import { storageData } from "../../../../services/Services";

const AddMember = (props) => {
    var { newMembers, memberList, index, setAddMember, changeReqContext, reqChangeClass, setChangeClass } = props
    const context = useContext(changeReqContext)
    var changeClass = context[reqChangeClass]
    var typeOfClass = (reqChangeClass == "householdChangeClass") ? "HouseholdChangeClass" : "AddressChangeClass"

    const [state, setState] = useState((index >= memberList.length) ? {
        DOB: "",
        mStatus: "",
        gender: "",
        dLicense: "",
        licenseNum: "",
        licenseState: context?.userData?.state,
        licenseOtherState: "",
        fullName: "",
        daySelect: "",
        yearSelect: "",
        monthSelect: "",
        licenseStatus: "",
        ownInsurance: "",
        memberStatus: "New Resident",
        initialType: "New",
        hideBtn: false,
        toggleAuto: false,
        show: false
    } : {
        ...memberList[index],
    })

    const validationMsg = useRef("")
    const validationTitle = useRef("")

    // Validation Modal
    const handleClose = () => setState({ ...state, show: false });
    const handleShow = () => setState({ ...state, show: true });

    // Retrieves Form Values
    const callback = (key, value) => {
        var info = { ...state };
        info[key] = value;
        setState({ ...info })
    }

    // Sets Validation Message
    const handleValidationMsg = (msg, title) => {
        validationMsg.current = msg
        validationTitle.current = title
    }

    // Adds member
    const addNewMember = (e) => {
        // Adds DOB format
        if (monthSelect && daySelect && yearSelect) {
            state.DOB = monthSelect + "/" + daySelect + "/" + yearSelect
        }

        var addedMember = state;
        if ((e.target.value) === "SAVE") {
            var check = AddMemberValidation({ infoFields: addedMember, handleValidationMsg, handleShow, userData: context.userData });
            if (check) {
                var changeClassCopy = changeClass
                var memberListContextCopy = changeClassCopy?.driversHHMs?.householdMembers?.newMembers
                var newMemberListCopy = memberList;

                // Adding New Member
                if (index > memberList.length) {
                    newMemberListCopy.push(state);
                }
                // Editng Member
                else {
                    newMemberListCopy[index] = state;
                }
                memberListContextCopy = newMemberListCopy
                setChangeClass(changeClassCopy)
                storageData.setItem(typeOfClass, JSON.stringify(changeClassCopy))
                setAddMember(false)
            }
            else {
                return
            }
        }
        else {
            setAddMember(false)
        }
        context.setEditAddedMemberArr([])
    };

    useEffect(() => {
        // Toggles Auto Questions
        if (state.fullName && state.monthSelect && state.daySelect && state.yearSelect) {
            var DOB = `${state.monthSelect}/${state.daySelect}/${state.yearSelect}`
            var atLeast16 = (Date.now() - new Date(DOB).getTime()) >= (16 * 365 * 24 * 60 * 60 * 1000)
            var newState = { ...state, DOB }

            if (atLeast16) {
                newState.toggleAuto = true
            } else {
                newState.toggleAuto = false
            }
            setState(newState)
        }
    }, [state.monthSelect, state.daySelect, state.yearSelect])

    var { fullName, monthSelect, daySelect, yearSelect, mStatus, gender, dLicense, licenseStatus, licenseOtherState, licenseNum, ownInsurance } = state;
    return (
        <>
            <div className="slide-toggle edit-section mt-2">
                <div className="form-group form-group-xs">
                    <h6 className="text-center household-text-blue less-margin fw-bold">
                        NEW HOUSEHOLD MEMBER
                    </h6>
                </div>
                <FormAuto
                    form={
                        [
                            {
                                id: "fullName",
                                type: "text",
                                label: "Full Name:",
                                value: fullName,
                                callback
                            },
                            {
                                id: { y: "yearSelect", m: "monthSelect", d: "daySelect" },
                                type: "dateSelect",
                                label: "Date of Birth:",
                                value: { y: yearSelect, m: monthSelect, d: daySelect },
                                callback
                            },
                            {
                                id: "mStatus",
                                type: "select",
                                label: "Marital Status:",
                                value: mStatus,
                                options: mStatusOpt,
                                col: {
                                    label: { xl: 4 },
                                    input: { xl: 6 },
                                },
                                callback
                            },
                            {
                                id: "gender",
                                type: "select",
                                label: "Gender:",
                                value: gender,
                                options: (state.userData?.state == "New Jersey") ? [...genderOpt, "Unspecified"] : genderOpt,
                                col: {
                                    label: { xl: 4 },
                                    input: { xl: 6 },
                                },
                                callback
                            },
                            (new Date().getFullYear() - parseInt(yearSelect) >= 16) &&
                            {
                                id: "dLicense",
                                type: "radio",
                                label: "Does this household member have a valid " + (context?.userData?.state == "New Jersey" ? "NJ" : "PA") + " driver's license?*",
                                value: dLicense,
                                options: [{ id: "1", value: "Yes" }, { id: "0", value: "No" }],
                                col: {
                                    label: { xs: 8 },
                                    input: { xs: 2 },
                                },
                                callback
                            },
                            // License Number (Valid License)
                            (dLicense == 1) &&
                            {
                                id: "licenseNum",
                                type: "text",
                                label: "License Number:",
                                value: licenseNum,
                                placeholder: "License Number",
                                callback
                            },
                            // License Status (Invalid License)
                            (dLicense === "0") &&
                            {
                                id: "licenseStatus",
                                type: "select",
                                label: "What is the status of this driver's license?",
                                value: licenseStatus,
                                col: {
                                    label: { xs: 4 }, input: { xs: 6 },
                                },
                                options: dlStatus,
                                callback
                            },
                            // License State (Invalid License)
                            (dLicense == "0" && licenseStatus == "Valid Other State License") &&
                            {
                                id: "licenseOtherState",
                                type: "select",
                                label: "Licensed State:",
                                value: licenseOtherState,
                                col: {
                                    label: { xs: 4 }, input: { xs: 6 },
                                },
                                options: states,
                                callback
                            },
                            // License Number (Invalid License)
                            (dLicense == "0" && (licenseStatus == "Valid Other State License" || licenseStatus == "Permit")) &&
                            {
                                id: "licenseNum",
                                type: "text",
                                label: "License Number:",
                                value: licenseNum,
                                callback
                            },
                            (dLicense == "1" && (new Date().getFullYear() - parseInt(yearSelect) >= 16)) &&
                            {
                                id: "ownInsurance",
                                type: "radio",
                                label: "Does this household member maintain their own auto insurance?",
                                value: ownInsurance,
                                col: {
                                    label: { xs: 12 },
                                    input: { xs: 2 },
                                },
                                options: [{ id: "1", value: "Yes" }, { id: "0", value: "No" }],
                                callback

                            }
                        ]
                    }
                />
                <hr className="less-margin my-3" />
                <div className="text-right my-3" onClick={addNewMember}>
                    <input type={"button"} className="btn btn-default btn-sm editCancelBtn" value={"CANCEL"} />
                    <input type={"button"} className="btn btn-primary-grad btn-sm ms-1 editCancelBtn" value={"SAVE"} />
                </div>
                <ValidationModal
                    show={state.show}
                    handleClose={handleClose}
                    validationMsg={validationMsg.current}
                    title={validationTitle.current}
                />
            </div>
        </>
    )
}

export default AddMember